import React from 'react'

export default function StatusDot({ bg = 'secondary' }) {
    return <span className={`legend-indicator bg-${bg}`} />
}
